import { css } from '@emotion/react'

export const scrollbarStyle = css`
  @media screen and (min-width: 768px) {
    &::-webkit-scrollbar {
      width: 16px;
      height: 16px;
    }

    &::-webkit-scrollbar-thumb {
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      border: none;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0,0,0,0.4);
      border-radius: 10px;
      border: 6px solid transparent;
      background-clip: padding-box;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0,0,0,0.6);
      border: 4px solid transparent;
      background-clip: padding-box;
    }
  }
`

export const scrollbarStyleDefaultHidden = css`
  @media screen and (min-width: 768px) {
    &::-webkit-scrollbar {
      width: 12px;
      height: 12px;
    }

    &::-webkit-scrollbar-thumb {
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &:hover::-webkit-scrollbar-thumb {
      background: rgba(0,0,0,0.4);
      border-radius: 10px;
      border: 4px solid transparent;
      background-clip: padding-box;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0,0,0,0.6);
      border: 2px solid transparent;
      background-clip: padding-box;
    }
  }
`